export default __webpack_public_path__ + "static/media/SCANIA_MINERIA_INTELIGENTE.850804e9.pdf";